export enum CoordinateSystem {
  WGS84 = 'WGS84',
  RD = 'RD'
}



// WEBPACK FOOTER //
// ./src/app/models/coordinate-system.ts